import { useInfiniteQuery } from "@tanstack/react-query";
import { getServicesMasterAutosuggest } from "apis";
import useQueueStore from "../../../stores/queue-store";
import { SERVICE_MASTER_STATUS } from "@elixir/types";
import { useMyAccessProfileV2 } from "../../tryst/get-my-access-profile";

export const getServicesMasterInfiniteScrollQuery = ({
  query,
  owner_id,
  clinic_id,
  status,
}: {
  query?: string;
  owner_id: string;
  clinic_id?: string;
  status?: SERVICE_MASTER_STATUS;
  searchInAllServiceTypes?: boolean
}) => {
  const queryArray = ["get-service-master-infinite-query", owner_id];
  if (query) {
    queryArray.push(query);
  }
  if (clinic_id) {
    queryArray.push(clinic_id);
  }
  if (status) {
    queryArray.push(status);
  }
  return queryArray;
};

export default function useGetServicesMasterInfiniteQuery({
  query = "",
  pageSize,
  status,
  clinicIdToFetch,
  searchInAllServiceTypes,
}: {
  query?: string;
  pageSize?: number;
  status?: SERVICE_MASTER_STATUS;
  clinicIdToFetch?: string;
  searchInAllServiceTypes?: boolean;
}) {
  const { data: myAccessProfile } = useMyAccessProfileV2();
  const clinic_id = useQueueStore((state) => state.clinicId);

  return useInfiniteQuery(
    getServicesMasterInfiniteScrollQuery({
      query,
      owner_id: myAccessProfile?.business?.id!,
      clinic_id: clinicIdToFetch || clinic_id,
      status: searchInAllServiceTypes ? undefined : status,
    }),
    ({ pageParam }) => {
      return getServicesMasterAutosuggest({
        q: query,
        page: pageParam || 1,
        pageSize,
        status,
        clinic_id: clinicIdToFetch || clinic_id,
        searchInAllServiceTypes,
      });
    },
    {
      // enabled: query.length > 0,
      staleTime: 1000 * 10,
      getNextPageParam: (currData) => {
        return currData.pagination?.next_page;
      },
    }
  );
}
